import request from "@/utils/request";
import {service2 as request2} from "@/utils/request";
// viewer, 用户访问数
export function getViewer(data) {
    return request({
        url: "/viewer",
        method: "get",
        data
    });
}
// 获取配置
export function getConfig(data) {
    return request({
        url: "/get_client_config",
        method: "post",
        data
    });
}
// 验证邮箱
export function postEmailCode(data) {
    return request({
        url: "/email/send_code",
        method: "post",
        data
    });
}
// 获取渠道列表
export function postChannelList(data) {
    return request({
        url: "/get_channel",
        method: "post",
        data,
    });
}
// 校验订单
export function postValidateOrderCode(data) {
    return request({
        url: "/check_order",
        method: "post",
        data,
    });
}
// 上传图片
export function postUploadPic(data) {
    return request({
        url: "/upload",
        method: "post",
        data
    });
}
// 提交表单
export function postSubmit(data) {
    return request({
        url: "/submit",
        method: "post",
        data
    });
}
// 提交信息
export function postUpdateStep(data) {
    return request({
        url: "/update_step",
        method: "post",
        data
    });
}
